import React from 'react'
import { Row, Col, Table } from 'reactstrap';
import { Link } from 'react-router'

import Loader from '../../core/components/Loader'

import Up from 'react-icons/lib/go/triangle-up'
import Down from 'react-icons/lib/go/triangle-down'


class DashboardDatas extends React.Component {

	constructor(props) {
        super(props);

        this.state={
            date:365
        }
    }

    componentDidMount() {
        this.props.newData(this.state.date, this.props.params.regionParam)
    }

    changeLead(date){
        this.setState({date:date});
        this.props.newData(date, this.props.params.regionParam)
    }

    render() {
        const{ datas } = this.props;

    	return (
             <Col xs="12" sm="3">
                <div className="bloc-datas-choice">
                    {/*<div onClick={() => this.changeLead(7)} className={this.state.date===7 ? 'active' : ''}>Cette semaine</div>*/}
                    {/*<div onClick={() => this.changeLead(30)} className={this.state.date===30 ? 'active' : ''}>Ce Mois</div>*/}
                    <div onClick={() => this.changeLead(365)} className={this.state.date===365 ? 'active' : ''}>Cette année</div>
                </div>
                <div className="bloc-datas-cercle">
                    {datas.fulfilled &&
                        datas.data.new
                    }
                </div>

                {this.props.type === "lead" && datas.fulfilled &&
                    <div>
                        <div className="bloc-datas-title"><Link to={"/manager/leads?date="+this.state.date}>Candidatures</Link></div>
                        {/*<div className="bloc-datas-percentage">*/}
                        {/*    {datas.data.percentage > 0 &&*/}
                        {/*        <div> <Up color="7fcc54"/> +{datas.data.percentage}% </div>*/}
                        {/*    }*/}

                        {/*    {datas.data.percentage < 0 &&*/}
                        {/*        <div> <Down color="e7342c"/> {datas.data.percentage}% </div>*/}
                        {/*    }*/}
                        {/*    {!datas.data.percentage &&*/}
                        {/*        <div> 0% </div>*/}
                        {/*    }*/}
                        {/*</div>*/}
                    </div>
                }

                {this.props.type === "provider" && datas.fulfilled &&
                    <div>
                        <div className="bloc-datas-title"><Link to={"/manager/prestataires?date="+this.state.date}>Candidatures retenues</Link></div>
                        {/*<div className="bloc-datas-percentage">*/}
                        {/*    {datas.data.percentage > 0 &&*/}
                        {/*        <div> <Up color="7fcc54"/> +{datas.data.percentage}% </div>*/}
                        {/*    }*/}

                        {/*    {datas.data.percentage < 0 &&*/}
                        {/*        <div> <Down color="e7342c"/> {datas.data.percentage}% </div>*/}
                        {/*    }*/}
                        {/*    {!datas.data.percentage &&*/}
                        {/*        <div> 0% </div>*/}
                        {/*    }*/}
                        {/*</div>*/}
                    </div>
                }

                {this.props.type === "task" && datas.fulfilled &&
                    <div>
                        <div className="bloc-datas-title"><Link to={"/manager/tasks?date="+this.state.date}>Candidatures à traiter</Link></div>
                    </div>
                }

            </Col>
        )
    }
}


export default DashboardDatas



// WEBPACK FOOTER //
// ./src/btob/components/DashboardDatas.js